
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.576 2.23l9.178 8.762a.834.834 0 01-1.151 1.207l-8.315-7.936a.417.417 0 00-.576 0L3.397 12.2a.834.834 0 01-1.151-1.207l9.178-8.762a.834.834 0 011.152 0zm-.288 3.603a.417.417 0 00-.576 0l-6.675 6.372a.417.417 0 00-.13.301v8.267c0 .461.374.835.835.835h12.516c.46 0 .834-.374.834-.835v-8.267a.417.417 0 00-.129-.301l-6.675-6.372zm3.884 10.026a.464.464 0 01-.464.464h-1.9a.417.417 0 00-.417.418v1.905a.463.463 0 01-.464.463h-1.854a.463.463 0 01-.464-.463V16.74a.417.417 0 00-.417-.418h-1.9a.464.464 0 01-.464-.463v-1.854a.463.463 0 01.464-.464h1.9c.23 0 .417-.186.417-.417v-1.9c0-.257.208-.464.464-.464h1.854a.464.464 0 01.464.463v1.901c0 .23.187.417.417.417h1.9a.464.464 0 01.464.463v1.854z","fill":"#0095DA"}})])
          )
        }
      }
    